<template>
  <div class="box">
    <div class="main-content">
      <!-- 课次列表部分开始 -->
      <div class="classTimesList">
        <!-- 输入课次搜索框 -->
        <div style="padding: 20px 30px; box-sizing: border-box">
          <div class="courseSearch-box flex align spaceBetween">
            <input v-model="courseName" @keyup.enter="courseSearch(courseName)" class="courseSearch" type="text"
              placeholder="输入课次名称" />
            <img @click="courseSearch(courseName)" class="pointer"
              src="../../assets/resourceManagement/searchIcon.png" />
          </div>
        </div>
        <!-- 课次列表标题 -->
        <div class="classTimesList-title-box flex align">
          <div style="width: 12px; height: 26px; background: #3096fb"></div>
          <div class="classTimesList-title">课次列表</div>
        </div>
        <!-- 课次列表 -->
        <div class="classList-box">
          <div @click="singleClass(item.id)" :class="currentClassesIdx == item.id ? 'allClasses' : 'classList'"
            v-for="(item, index) in allListClasses" :key="index">
            <div class="classList-circle"></div>
            <div class="classList-num">课次{{ index + 1 }}</div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 课次列表部分结束 -->
      <!-- 学生列表部分开始 -->
      <div class="studentList-content">
        <!-- 班级选择器 -->
        <div class="flex align justify" style="margin-top: 20px">
          <div class="selector-txt">班级</div>
          <el-cascader v-model="classValue" @change="classHandleChange" :options="classOptions"></el-cascader>
        </div>
        <!-- 输入学生搜索框 -->
        <div style="padding: 20px 30px; box-sizing: border-box">
          <div class="studentSearch-box flex align spaceBetween">
            <input v-model="studentName" @keyup.enter="studentSearch(studentName)" class="studentSearch" type="text"
              placeholder="输入学生名" />
            <img @click="studentSearch(studentName)" class="pointer"
              src="../../assets/resourceManagement/searchIcon.png" />
          </div>
        </div>
        <!-- 学生列表 -->
        <div class="studentList-box">
          <div @click="selectStudents(index)" v-for="(item, index) in studentList" :key="index"
            :class="currentStudentIdx == index ? 'selectStudents' : 'unSelectStudents'">
            <div class="flex align">
              <img class="rankImg" v-if="index == 0" src="@/assets/first.png" />
              <img class="rankImg" v-if="index == 1" src="@/assets/second.png" />
              <img class="rankImg" v-if="index == 2" src="@/assets/third.png" />
              <div class="student-ranking" v-if="index != 0 && index != 1 && index != 2">{{ index + 1 }}</div>
              <img class="head-sculpture" :src="item.icon != '' ? item.icon : require('@/assets/head.png')" />
              <div class="flex column spaceBetween" style="margin-left: 10px">
                <div class="studentTxt">{{ item.name }}</div>
                <div class="studentTxt">{{ item.account }}</div>
              </div>
            </div>
            <div class="flex align">
              <div class="integral-num">{{ item.coursePoints }}</div>
              <div class="integral-txt">积分</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 学生列表部分结束 -->
      <!-- 学生详情部分开始 -->
      <div v-if="studentList.length != 0" class="studentDetails-content">
        <div class="studentDetails-top flex align spaceBetween">
          <div class="flex align">
            <img class="studentDetails-headSculpture" src="@/assets/head.png" />
            <div style="margin-left: 18px">
              <div class="studentDetails-txt">{{ studentList[currentStudentIdx].name }}</div>
              <div class="studentDetails-txt">{{ studentList[currentStudentIdx].account }}</div>
            </div>
          </div>
          <div class="flex align">
            <div class="studentDetails-num">{{ studentList[currentStudentIdx].coursePoints }}</div>
            <div class="studentDetails-text">积分</div>
          </div>
        </div>
        <div class="tableStyle flex column align">
          <!-- <div v-show="showDetail">
            <echartsPie :preData="preData[0]"></echartsPie>
            <echartsPie :preData="preData[1]"></echartsPie>
            <echartsPie :preData="preData[2]"></echartsPie>
            <div @click="showDetail = false" class="btnDetail flex align justify pointer">查看详情</div>
          </div> -->
          <!-- 教学实施部分开始 -->
          <div class="tableWidth">
            <div class="resourceList-h1Box flex align">
              <div class="resourceList-colorBlock"></div>
              <div class="resourceList-h1">教学实施</div>
            </div>
            <!-- 课前准备部分开始 -->
            <div style="margin-top: 2px">
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课前准备</div>
              </div>
              <el-table :data="beforeClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
              </el-table>
            </div>
            <!-- 课前准备部分结束 -->
            <!-- 课堂教学部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课堂教学</div>
              </div>
              <el-table :data="middleClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
              </el-table>
            </div>
            <!-- 课堂教学部分结束 -->
            <!-- 课后巩固部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课后巩固</div>
              </div>
              <el-table :data="afterClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
              </el-table>
            </div>
            <!-- 课后巩固部分结束 -->
          </div>
          <!-- 教学实施部分结束 -->
        </div>
      </div>
      <!-- 学生详情部分结束 -->
    </div>
  </div>
</template>

<script>
import { courseLearningRecords, obtainTeacherTeachingClass } from "@/api";
import echartsPie from "@/components/echarts_pie";
import store from "@/store";
export default {
  data() {
    return {
      allListClasses: [], // 课次列表
      currentClassesIdx: 0, // 当前课次
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      studentList: [], // 学生列表
      studentList1: [], // 学生搜索列表
      currentStudentIdx: 0, // 当前学生
      resourceList: [], // 资源列表
      beforeClassList: [], // 课前列表
      middleClassList: [], // 课中列表
      afterClassList: [], // 课后列表
      showDetail: true, // 是否展示详情
      answerRecordList: [], // 答题记录列表
      courseName: "", // 课次搜索的课次名称
      studentName: "", // 学生搜索的学生名称
      preData: [
        {
          show: true,
          typeList: [
            { value: 1, name: "资源观看" },
            { value: 2, name: "观看时长" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 70 + "分}",
        },
        {
          show: true,
          typeList: [
            { value: 1, name: "客观题正确率" },
            { value: 2, name: "主观题完成度" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 70 + "分}",
        },
        {
          show: true,
          typeList: [
            { value: 1, name: "作业完成度" },
            { value: 2, name: "作业正确率" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 70 + "分}",
        },
      ],
    };
  },
  components: { echartsPie },
  created() {
    // 调用获取老师授课班级列表接口
    let params = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params).then((res) => {
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 调用获取数据方法
      this.publicGettingDataFunc();
    });
    // 获取当前课程全部课次的数据
    this.allListClasses = this.$store.state.classListRecord;
    this.currentClassesIdx = this.$store.state.classListRecord[0].id;
  },
  methods: {
    // 课次搜索
    courseSearch(name) {
      this.allListClasses = [];
      for (let i = 0; i < this.$store.state.classListRecord.length; i++) {
        if (this.$store.state.classListRecord[i].name.indexOf(name) >= 0) {
          this.allListClasses.push(this.$store.state.classListRecord[i]);
        }
      }
    },
    // 学生搜索
    studentSearch(name) {
      console.log(name);
      this.studentList = [];
      // console.log(this.studentList);
      for (let i = 0; i < this.studentList1.length; i++) {
        if (this.studentList1[i].name.indexOf(name) >= 0) {
          this.studentList.push(this.studentList1[i]);
        }
      }
    },
    // table行的 className 的回调方法
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      let cellStyle;
      if (row.completed == true) {
        cellStyle = "color:#12A13A";
      } else {
        cellStyle = "";
      }
      return cellStyle;
    },
    // 排序
    compare(property, desc) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc == true) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    // 获取数据
    publicGettingDataFunc() {
      let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
      courseLearningRecords(params).then((res) => {
        // 获取学生表格数据
        for (let i in res.data.ext.users) {
          let publicRes = res.data.ext.users[i];
          this.studentList = res.data.ext.users; // 获取学生列表
          this.studentList1 = res.data.ext.users; // 获取学生列表
          publicRes.coursePoints = 0; // 课次积分
          for (let j in res.data.ext.lesson_user) {
            if (publicRes.account == res.data.ext.lesson_user[j].user_account) {
              if (this.currentClassesIdx == res.data.ext.lesson_user[j].lesson_item_id) {
                console.log(res.data.ext.lesson_user[j]);
                publicRes.coursePoints += res.data.ext.lesson_user[j].score; // 计算单个课次课程积分
              }
            }
          }
        }
        this.studentList.sort(this.compare("coursePoints", false)); // 排名排序
        this.studentList1.sort(this.compare("coursePoints", false)); // 排名排序
        // 获取资源数据
        let courseResources = res.data.datas.filter((item) => item.lesson_item_id == this.currentClassesIdx);
        // 课次答题记录
        let answerRecordList = res.data.ext.lesson_user.filter(({ lesson_item_id, user_account }) => lesson_item_id == this.currentClassesIdx && user_account == this.studentList[this.currentStudentIdx].account);
        for (let i in courseResources) {
          let publicRes = courseResources[i];
          if (publicRes.types == "assets") {
            publicRes.assets.link_id = publicRes.id;
            publicRes.assets.typesOf = "资源";
            if (publicRes.assets.types == "video") {
              publicRes.assets.types = "视频资源";
            } else if (publicRes.assets.types == "audio") {
              publicRes.assets.types = "音频资源";
            } else if (publicRes.assets.types == "doc") {
              publicRes.assets.types = "文档资源";
            } else if (publicRes.assets.types == "image") {
              publicRes.assets.types = "图片资源";
            } else if (publicRes.assets.types == "web") {
              publicRes.assets.types = "资源链接";
            } else if (publicRes.assets.types == "h5") {
              publicRes.assets.types = "特殊互动";
            }
            publicRes.assets.score1 = publicRes.assets.score + "分"; // 转换分数格式
            publicRes.assets.created = publicRes.assets.created.substring(0, 10);
            this.resourceList.push(publicRes.assets);
          } else if (publicRes.types == "examitem") {
            publicRes.exam_item.link_id = publicRes.id;
            publicRes.exam_item.typesOf = "习题";
            if (publicRes.exam_item.types == "single") {
              publicRes.exam_item.types = "单选题";
            } else if (publicRes.exam_item.types == "multi") {
              publicRes.exam_item.types = "多选题";
            } else if (publicRes.exam_item.types == "truefalse") {
              publicRes.exam_item.types = "判断题";
            } else if (publicRes.exam_item.types == "answer") {
              publicRes.exam_item.types = "简答题";
            }
            publicRes.exam_item.score1 = publicRes.exam_item.score + "分"; // 转换分数格式
            publicRes.exam_item.name = publicRes.exam_item.content.replace(/<[^>]+>/g, ""); // 转换名字格式
            publicRes.exam_item.created = publicRes.exam_item.created.substring(0, 10);
            this.resourceList.push(publicRes.exam_item);
          } else if (publicRes.types == "exam") {
            publicRes.exam.link_id = publicRes.id;
            publicRes.exam.typesOf = "作业";
            if (publicRes.exam.types == "manual") {
              publicRes.exam.types = "手动";
            } else if (publicRes.exam.types == "auto") {
              publicRes.exam.types = "自动";
            }
            publicRes.exam.num_item = publicRes.exam.num_item + "道"; // 转换题数格式
            publicRes.exam.score1 = publicRes.exam.score + "分"; // 转换分数格式
            publicRes.exam.created = publicRes.exam.created.substring(0, 10);
            this.resourceList.push(publicRes.exam);
          }
        }
        for (let i in this.resourceList) {
          let publicRes = this.resourceList[i];
          publicRes.completed = false;
          console.log(answerRecordList);
          if (publicRes.typesOf == "资源") {
            for (let j in answerRecordList) {
              if (publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].score > 0) {
                publicRes.completed = true;
              }
            }
          } else if (publicRes.typesOf == "习题") {
            for (let j in answerRecordList) {
              if (publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].score > 0) {
                publicRes.completed = true;
              }
            }
          } else if (publicRes.typesOf == "作业") {
            let examScore = 0;
            for (let j in answerRecordList) {
              if (answerRecordList[j].link_type == "exam" && publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].link_exam_item_id) {
                examScore += answerRecordList[j].score;
              }
              if (examScore == publicRes.score) {
                publicRes.completed = true;
              }
            }
          }
          if (publicRes.usage == "front") {
            this.beforeClassList.push(publicRes); // 课前准备数据获取
          } else if (publicRes.usage == "middle") {
            this.middleClassList.push(publicRes); // 课堂教学数据获取
          } else if (publicRes.usage == "back") {
            this.afterClassList.push(publicRes); // 课后巩固数据获取
          }
        }
        console.log("课前", this.beforeClassList);
        console.log("课中", this.middleClassList);
        console.log("课后", this.afterClassList);
      });
    },
    // 选中单个课次的逻辑
    singleClass(idx) {
      this.currentClassesIdx = idx; // 获取课次id
      this.studentList = []; // 清空学生列表
      this.studentList1 = []; // 清空学生搜索列表
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 选中学生
    selectStudents(idx) {
      this.currentStudentIdx = idx;
      this.studentList = []; // 清空学生列表
      this.studentList1 = []; // 清空学生搜索列表
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 班级选择器
    classHandleChange(value) {
      this.classId = value[1];
      this.classValue[1] = value[1]; // 获取班级id
      this.studentList = []; // 清空学生列表
      this.studentList1 = []; // 清空学生搜索列表
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
}

/* 课次列表部分 */
.classTimesList {
  width: 466px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  height: calc(100vh - 315px);
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

/* 课次列表 */
.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

/* 学生列表部分 */
.studentList-content {
  width: 404px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.studentSearch-box {
  width: 334px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.studentSearch {
  width: 220px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.studentList-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 315px);
  overflow: scroll;
}

.student-ranking {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 40px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.selectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #eaeaea;
  padding: 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.unSelectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #ffffff;
  padding: 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.head-sculpture {
  margin-left: 11px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.studentTxt {
  font-size: 16px;

  font-weight: 400;
  color: #555555;
}

.integral-num {
  font-size: 30px;

  font-weight: 400;
  color: #349afe;
}

.integral-txt {
  margin-top: 9px;
  font-size: 14px;

  font-weight: 400;
  color: #555555;
}

.studentDetails-top {
  width: 868px;
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.studentDetails-headSculpture {
  width: 86px;
  height: 86px;
}

.studentDetails-txt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.studentDetails-num {
  font-size: 48px;

  font-weight: 400;
  color: #349afe;
}

.studentDetails-text {
  margin-top: 13px;
  font-size: 24px;

  font-weight: 400;
  color: #555555;
}

.btnDetail {
  margin-top: 40px;
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
}

.resourceList-h1Box {
  padding-left: 20px;
  height: 60px;
  background: #cce6ff;
}

.resourceList-colorBlock {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.resourceList-h1 {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.resourceList-h2Box {
  padding-left: 30px;
  height: 50px;
  background: #eaeaea;
}

.resourceList-round {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.resourceList-h2 {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 22px;
}

.tableWidth {
  width: 860px;
}

.tableStyle {
  height: calc(100vh - 280px);
  box-sizing: border-box;
  overflow: scroll;
}

.rankImg {
  width: 46px;
  height: 40px;
}
</style>
